import { BoxProps, Heading, Stack, Text } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';

type Props = BoxProps & {
  title?: any;
  description?: any;
  children?: any;
};

export const EmailDrawerLeftPanel = ({ title, description, children }: Props) => {
  return (
    <Stack flex={1} borderRightWidth={1} overflowY="auto" p={6} spacing={6}>
      <Show if={!!title || !!description}>
        <Stack>
          <Show if={!!title}>
            <Heading as="h3" size="md">
              {title}
            </Heading>
          </Show>
          <Show if={!!description}>
            <Text size="sm" color="gray.500">
              {description}
            </Text>
          </Show>
        </Stack>
      </Show>
      {children}
    </Stack>
  );
};
